import { createContext } from 'react';

export const MenuContext = createContext({
    getItemProps: () => ({}),
    activeIndex: null,
    setActiveIndex: () => {},
    isOpen: false
});
